import React from 'react';
// Import the corresponding CSS file
import './TermsAndConditions.css'; 

const TermsAndConditions = () => {

    // Storing the terms in a data array makes the content easy to update and manage.
    const termsData = [
        {
            title: 'Acceptance of Terms',
            content: 'By accessing and using our website, you agree to comply with and be bound by these terms and conditions. If you do not agree with any part of these terms, please refrain from using our services.'
        },
        {
            title: 'Booking and Payment',
            content: 'All bookings are subject to availability and confirmation. Prices displayed on the website include applicable taxes and fees. Payment must be made in full at the time of booking, and we accept various secure payment methods.'
        },
        {
            title: 'Cancellation and Refund',
            content: 'Cancellation policies vary by airline and holiday package. Please review the specific terms during the booking process. Refunds, if applicable, will be processed according to the cancellation policy and may be subject to fees.'
        },
        {
            title: 'Changes and Amendments',
            content: 'Changes to bookings are subject to availability and the terms and conditions of the respective airline or holiday provider. Any additional costs resulting from changes will be the responsibility of the traveler.'
        },
        {
            title: 'Travel Insurance',
            content: 'We recommend purchasing travel insurance to protect against unforeseen circumstances. The availability of travel insurance options will be presented during the booking process.'
        },
        {
            title: 'User Accounts',
            content: 'Users are responsible for maintaining the confidentiality of their account information and password. Any activities conducted through the user\'s account are their responsibility. Notify us immediately of any unauthorized use of your account.'
        },
        {
            title: 'Privacy Policy',
            content: 'Our Privacy Policy outlines how we collect, use, and protect your personal information. By using our services, you consent to the terms of our Privacy Policy.'
        },
        {
            title: 'Limitation of Liability',
            content: 'We are not liable for any direct, indirect, incidental, consequential, or punitive damages arising from the use of our website or services. This includes, but is not limited to, errors, omissions, interruptions, or delays.'
        },
        {
            title: 'Force Majeure',
            content: 'We shall not be held liable for any failure or delay in performance resulting from acts beyond our control, including but not limited to natural disasters, government actions, or technological failures.'
        }
    ];

    // Placeholder style for the hero background. Choose an image that fits the professional tone.
    const heroStyle = {
        backgroundImage: `url('/assets/images/Terms.png')`, // A professional, document-related image
    };

    return (
        <div className="main-content">
            {/* Hero Section for consistency */}
            <div className="terms-hero-section" style={heroStyle}>
                <div className="hero-overlay">
                    <div className="container text-center">
                        <h1 className="hero-heading">Terms & Conditions</h1>
                        <p className="hero-subheading">Please read our terms carefully before using our services.</p>
                    </div>
                </div>
            </div>

            {/* Main Page Content */}
            <div className="page-content">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="terms-content-wrapper">
                                {termsData.map((term, index) => (
                                    <div className="terms-section" key={index}>
                                        <h3 className="terms-title">{term.title}</h3>
                                        <p className="terms-text">{term.content}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;